<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('internship_application') + ' - ' + $t('detail')" :isFilter="false" />
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('internship_application') + ' - ' + $t('detail')" :isFilter="false" />
			</template>
			<b-row class="mb-5">
				<b-col cols="12">
					<b-card no-body class="soft">
						<b-tabs card>
							<!-- TAB 1: ÖĞRENCİ BİLGİLERİ -->
							<b-tab :title="$t('student_information')" active>
								<b-row class="p-3">
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('student_number')">
											<div class="font-weight-bold">{{ internshipData.student_number }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('name_surname')">
											<div class="font-weight-bold">{{ internshipData.name + ' ' + internshipData.surname }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('email')">
											<div class="font-weight-bold">{{ internshipData.email }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('faculty')">
											<div class="font-weight-bold">{{ getLocaleText(internshipData, 'faculty_name') }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('department')">
											<div class="font-weight-bold">{{ getLocaleText(internshipData, 'department_name') }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('program')">
											<div class="font-weight-bold">{{ getLocaleText(internshipData, 'program_name') }}</div>
										</b-form-group>
									</b-col>
								</b-row>
							</b-tab>

							<!-- TAB 2: STAJ BİLGİLERİ -->
							<b-tab :title="$t('internship_information')">
								<b-row class="p-3">
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('company_name')">
											<div class="font-weight-bold">{{ internshipData.company_name }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('company_phone')">
											<div class="font-weight-bold">{{ internshipData.company_phone }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('responsiblePerson')">
											<div class="font-weight-bold">{{ internshipData.responsible_name + ' ' + internshipData.responsible_surname }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('responsible_email')">
											<div class="font-weight-bold">{{ internshipData.responsible_email }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('unit')">
											<div class="font-weight-bold">{{ internshipData.unit }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('day_count')">
											<div class="font-weight-bold">{{ internshipData.day_count }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('course_code')">
											<div class="font-weight-bold">{{ internshipData.course_code }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('type')">
											<div class="font-weight-bold">{{ internshipData.type === 'voluntary' ? $t('voluntary') : $t('mandatory') }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('start_date')">
											<div class="font-weight-bold">{{ internshipData.start_date }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('end_date')">
											<div class="font-weight-bold">{{ internshipData.end_date }}</div>
										</b-form-group>
									</b-col>
								</b-row>
							</b-tab>

							<!-- TAB 3: ÜCRET BİLGİLERİ -->
							<b-tab :title="$t('fee_information')">
								<b-row class="p-3">
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('iban')">
											<div class="font-weight-bold">{{ internshipData.iban }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('pay_type')">
											<div class="font-weight-bold">{{ getLocaleText(internshipData, 'payment_type_name')}}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('calculation_type')">
											<div class="font-weight-bold">{{ getLocaleText(internshipData, 'calculate_type_name') }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('currency')">
											<div class="font-weight-bold">{{ getLocaleText(internshipData, 'currency_name') }}</div>
										</b-form-group>
									</b-col>
									<b-col cols="12" sm="6" md="4" class="mb-3">
										<b-form-group :label="$t('job') + ' ' + $t('code')">
											<div class="font-weight-bold">{{ getLocaleText(internshipData, 'job_code_name') }}</div>
										</b-form-group>
									</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
			<div>
                <div class="p-4 table-responsive">
                    <h3 class="mb-4">{{$t('documents')}}</h3>
                    <b-table
                        striped
                        hover
                        :items="documents"
                        :fields="fields1"
                        show-empty
                        empty-text="Gösterilecek belge bulunamadı."
                    >
                        <template #cell(actions)="data">
                            <div class="d-flex">
                                <b-button
                                    size="sm"
                                    variant="outline-primary"
                                    @click="downloadDocument(data?.item)"
                                    class="mr-2"
                                    :disabled="data.item.status === 'waiting'"
                                    title="Belgeyi İndir"
                                >
                                    <i class="ri-download-cloud-2-line mr-1"></i> {{$t('download')}}
                                </b-button>

                                <b-button
                                    v-if="!['DCFK'].includes(activeRol)"
                                    size="sm"
                                    variant="outline-success"
                                    @click="approveDocument(data?.item,'approved')"
                                    :disabled="data.item.status === 'approved' || data.item.status === 'waiting'"
                                    class="mr-2"
                                    :title="$t('approved')"
                                >
                                    <i class="ri-check-line mr-1"></i> {{$t('approved')}}
                                </b-button>

                                <b-button
                                    v-if="!['DCFK'].includes(activeRol)"
                                    size="sm"
                                    variant="outline-danger"
                                    @click="approveDocument(data.item,'declined')"
                                    :disabled="data?.item?.status === 'declined' || data.item.status === 'waiting'"
                                    :title="$t('declined')"
                                >
                                    <i class="ri-close-line mr-1"></i> {{$t('declined')}}
                                </b-button>
                            </div>
                        </template>
                        <template #cell(status)="data">
                            <b-badge
                                :variant="getStatusBadgeVariant(data.item.status)"
                            >
                                {{ data.item.status }}
                            </b-badge>
                        </template>
                    </b-table>
                </div>

				<div class="mb-3 d-inline-block"></div>
				<div v-if="internshipData && step.id && approvers === activeRol">
					<h6 class="text-uppercase mb-4">{{ $t('approval_procedures').toUpper() }}</h6>
					<ValidationObserver ref="updateForm">
						<div class="row">
                            <template v-if="['HR'].includes(activeRol)">
                                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                    <ValidationProvider name="document_type" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('document_type')">
                                            <ParameterSelectbox code="internship_application.hr_document_types" v-model="updateForm.document_type" :validateError="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>

                                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                    <ValidationProvider name="job_code" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('job') + ' ' + $t('code')">
                                            <ParameterSelectbox code="internship_application.occupation_codes" v-model="updateForm.job_code" :validateError="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                    <ValidationProvider name="payment_type" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('pay_type')">
                                            <ParameterSelectbox code="internship_application.payment_types" v-model="updateForm.payment_type" :validateError="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                    <ValidationProvider name="calculate_type" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('calculation_type')">
                                            <ParameterSelectbox code="internship_application.calculate_types" v-model="updateForm.calculate_type" :validateError="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                    <ValidationProvider name="currency" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('fee_information')">
                                            <ParameterSelectbox code="internship_application.currencies" v-model="updateForm.currency" :validateError="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                    <ValidationProvider name="salary" rules="required" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('paid_statuses')">
                                            <b-form-input v-model="updateForm.salary">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                    <ValidationProvider name="iban" rules="" v-slot="{valid, errors}" >
                                        <b-form-group :label="$t('iban')">
                                            <b-form-input type="text"
                                                          readonly
                                                          v-model="internshipData.iban"
                                                          v-mask="['AA##-####-####-####-####-####-##']"
                                                          :state="errors[0] ? false : null">
                                            </b-form-input>
                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </div>
                            </template>
							<div class="col-10 mt-5">
                                <h5>{{$t('application_status')}}</h5>
                                <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('status')">
                                        <template>
                                            <div>
                                                <multiselect placeholder="Yok" v-model="updateForm.status"
                                                             :options="computeStatusOptions"
                                                             :custom-label="statusOptionsCustomLabel" :select-label="''"
                                                             :selected-label="''" :deselect-label="''" :searchable="false">
                                                </multiselect>
                                                <div class="invalid-feedback d-block" v-if="errors[0]"
                                                     v-html="errors[0]"></div>
                                            </div>
                                        </template>
                                    </b-form-group>
                                </ValidationProvider>
							</div>
							<div class="col-12 col-md-6 col-lg-6 col-xl-9" v-if="['declined'].includes(updateForm.status)">
								<ValidationProvider name="explanation" rules="required" v-slot="{ valid, errors }">
									<b-form-group :label="$t('explanation')">
										<b-form-textarea no-resize rows="4" class="h-40 h-auto-sm" maxlength="100"
										                 v-model="updateForm.reason"></b-form-textarea>
										<div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
									</b-form-group>
								</ValidationProvider>
							</div>
						</div>
						<b-form-group>
							<b-button variant="primary" @click="internshipUpdate">
                                {{ $t('update').toUpper() }}
							</b-button>
						</b-form-group>
					</ValidationObserver>
				</div>
				<div v-if="Object.assign(steps).length">
					<b-table :empty-text="$t('there_are_no_records')" bordered striped responsive :items="steps"
					         :fields="[
                            { key: 'rank', label: this.toUpperCase('rank'), thClass: 'text-center', tdClass: 'text-center' },
                            { key: 'approvers', label: this.toUpperCase('can_approvers'), thClass: 'text-center' },
                            { key: 'approved', label: this.toUpperCase('approved_by'), thClass: 'text-center' },
                            { key: 'status', label: this.toUpperCase('status'), thClass: 'text-center' },
                            { key: 'reason', label: this.toUpperCase('explanation'), thClass: 'text-center' },
                            { key: 'updated_at', label: this.toUpperCase('updated_at'), thClass: 'text-center' },
                            { key: 'buttons', label: '', tdClass:'width-200'}
                        ]" show-empty sort-by="rank" class="mb-3 table-dropdown no-scrollbar border rounded">
						<template #cell(approvers)="data">
                            <span v-for="approver in data.item.approvers">
                                {{ getLocaleText(approver, 'explanation') }} <br>
                            </span>
						</template>
						<template #cell(approved)="data">
                            <span v-for="approver in data.item.approved">
                                {{ approver.name }} {{ approver.surname }}<br>
                            </span>
						</template>
						<template #cell(status)="data">
                            {{getLocaleText(data.item,'status_name')}}
						</template>
                        <template #cell(buttons)="row">
                            <div class="d-flex">
                                <b-button variant="outline-success"
                                          size="xs"
                                          v-if="row.item.allow_set_active && checkPermission('approvalstep_setactive')"
                                          @click="setActive(row.item.id)">
                                    {{ $t('set_as_active_step').toUpper() }}
                                </b-button>
                            </div>
                        </template>
					</b-table>
				</div>
			</div>
		</app-layout>
	</div>
</template>
<script>
	// Template
	import AppLayout from "@/layouts/AppLayout";
	import Header from "@/layouts/AppLayout/Header";
	import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

	// Services
	import InternshipApplicationService from "@/services/InternshipApplicationService";
	import ApprovalStepService from "@/services/ApprovalStepService";

	// Components
	import CommonModal from "@/components/elements/CommonModal"

// Other
	import {ValidationProvider, ValidationObserver} from "vee-validate"
    import internshipApplicationService from "@/services/InternshipApplicationService";

	export default {
		components: {
			AppLayout,
			Header,
			HeaderMobile,
			CommonModal,
			ValidationProvider,
			ValidationObserver,
		},
		data() {
			return {
				id: this.$route.params.id,
				internshipData: {
                    iban:null
                },
				step: {},
                fields1: [
                    { key: this.getLocaleField('type_name'), label: 'Belge Adı', sortable: true },
                    { key: 'status', label: 'Durum', sortable: true },
                    { key: 'actions', label: '', class: 'text-right' }
                ],
                documents: [],
				steps: {},
				messages: {},
				statuses: {},
				updateForm: {
					status: null,
					reason: null,
				},
				form: {
					explanation: ''
				},
	            formLoading: false,
				fields: [
					{
						key: 'created_by',
						label: this.toUpperCase('created_by'),
						thClass: 'text-left',
					},
					{
						key: 'message',
						label: this.toUpperCase('message'),
						thClass: 'text-left'
					},
					{
						key: 'created_at',
						label: this.toUpperCase('created_at'),
						thClass: 'text-left',
						formatter: this.formatDate,
					},
				],
				isTableVisible: false,
                formProcess: null,
                statusOptions: [
                    { text: this.$t('approved'), value: true },
                    { text: this.$t('declined'), value: false },
                ],
			}
		},

		metaInfo() {
			return {
				title: this.$t('internship_application') + ' - ' + this.$t('detail')
			}
		},
		created() {
			this.getData();

		},
		computed: {
            activeRol(){
                let role = this.$store.getters['auth/getUser']
                return role?.active_role?.name
            },
            approvers(){
                return this.internshipData?.active_step?.approvers?.[0].name
            },
            computeStatusOptions() {
                let options = [];
                if (this.statuses) {
                    for (const item in this.statuses) {
                        options.push(item);
                    }
                }
                return options;
            },
		},
		methods: {
			getData() {
				InternshipApplicationService.get(this.id)
				.then(response => {
                    this.internshipData = response.data.data;
                    this.step = this.internshipData.step == null ? {} : this.internshipData.step;
					if (this.internshipData.step != null) {
                        this.statuses = this.internshipData.step.statuses;
                    }
					this.steps = this.internshipData.steps == null ? {} : this.internshipData.steps;
                    this.documents = this.internshipData.documents
                    this.checkRole()
				})
				.catch(e => {
                    this.showMessage(e,null);
				})

			},
			async internshipUpdate() {
                if (this.checkPermission('internshipapplication_sendapprove')) {
                    const isValid = await this.$refs.updateForm.validate();

                    if (isValid) {
                        this.$swal.fire({
                            title: this.$t('warning'),
                            text: this.$t('leave_of_absence_statement'),
                            showCancelButton: true,
                            confirmButtonText: this.$t('yes'),
                            cancelButtonText: this.$t('no'),
                        }).then((result) => {
                            if (result.isConfirmed) {
                                if (['approved'].includes(this.updateForm.status)) {
                                    delete this.updateForm.reason;
                                }
                                InternshipApplicationService.update(this.step.id, this.updateForm)
                                    .then(response => {
                                        this.$toast.success(this.$t('api.' + response.data.message));
                                        this.getData()
                                    })
                                    .catch(error => {
                                        if (error.status == 422) {
                                            if (error.data.errors.status) {
                                                this.$refs.updateForm.errors.status.push(error.data.errors.status[0]);
                                            }
                                            if (error.data.errors.reason) {
                                                this.$refs.updateForm.errors.explanation.push(error.data.errors.reason[0]);
                                            }
                                        }
                                        if (error.status == 406) {
                                            this.$toast.error(this.$t('api.' + error.data.message));
                                        }
                                    });
                            }
                        })
                    }
                }
            },
            statusOptionsCustomLabel(key) {
                let label = key;
                if (this.statuses[key]) {
                    label = this.$i18n.locale == 'tr' ? this.statuses[key].name : this.statuses[key].name_en;
                }
                return label;
            },
            setActive(id){
                this.$swal.fire({
                    text: this.$t('are_you_sure_to_set_active'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        ApprovalStepService.setActive(id).then(response=>{
                            this.showMessage(response);
                            this.getData();
                        }).catch(e=>{
                            this.showErrors(e);
                        });
                    }
                });
			},
            approveDocument(document,status) {
                this.$swal.fire({
                    title: this.$t('warning'),
                    text: this.$t('approve_or_reject_confirm'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        const data ={
                            internship_application_id:this.$route.params.id,
                            type:document.type,
                            status:status,
                        }
                        InternshipApplicationService.sendApprovedDocument(data)
                            .then(response => {
                                this.$toast.success(this.$t('proccess_success'));
                                this.getData()
                            })
                            .catch(error => {
                                this.showErrors(error,null)
                            });
                    }
                })


            },
            downloadDocument(document) {
                const data ={
                    internship_application_id:this.$route.params.id,
                    type:document.type,
                    student_program_id:this.internshipData.student_program_id,
                }
                internshipApplicationService.showDocuments(data)
                    .then(res=>{
                        this._downloadFile(res, document.type_name +'.'+(res.headers.file_extension??'pdf'))

                    }).catch((err)=>{
                        this.showErrors(err,null)
                })


            },
            getStatusBadgeVariant(status) {
                switch(status) {
                    case 'approved': return 'success';
                    case 'declined': return 'danger';
                    default: return 'warning';
                }
            },
            checkRole(){
                if (['DCFK'].includes(this.activeRol)){
                    this.fields1=this.fields1.filter(item => {
                        return item.key !== 'status'
                    })
                }
            }
		},
	};
</script>
